// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mark-hl{
    background-color: red;
    padding: 0;
    font-weight: 600
}`, "",{"version":3,"sources":["webpack://./src/components/SearchBar/SearchBar.scss"],"names":[],"mappings":"AAAA;IACI,qBAAqB;IACrB,UAAU;IACV;AACJ","sourcesContent":[".mark-hl{\n    background-color: red;\n    padding: 0;\n    font-weight: 600\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
